<template>
  <li class="footer-meta__list-item">
    {{ ueberschrift }}:
    <ul>
      <li v-for="menu in menue" v-bind:key="menu.id" class="footer-meta__list-item--level2">
        <router-link v-bind:to="menu.url" class="footer-meta__link">
          {{ menu.menue }}
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'FooterMenue',
  props: {
    menue: {
      type: Object,
    },
    ueberschrift: {
      type: String,
    },
  },
};
</script>
